import React, { useEffect, useRef } from 'react';
import { Button, Spin } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearSsoSession } from '../../services/mobileSso';
import './LoginScreen.css';

interface RedirectingState {
  authorizeUrl?: string;
}

const SsoRedirectingScreen: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state || {}) as RedirectingState;
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    if (!state.authorizeUrl) {
      navigate('/login', { replace: true });
      return;
    }
    started.current = true;
    const timer = window.setTimeout(() => {
      window.location.assign(state.authorizeUrl!);
    }, 400);
    return () => window.clearTimeout(timer);
  }, [state.authorizeUrl, navigate]);

  const handleCancel = () => {
    clearSsoSession();
    navigate('/login', { replace: true });
  };

  return (
    <div className="login-container sso-status-screen">
      <div className="sso-status-content">
        <Spin size="large" />
        <h1 className="sso-status-title">Opening secure sign-in…</h1>
        <p className="sso-status-body">
          You&apos;re being taken to your organization&apos;s sign-in page in your browser.
        </p>
        <Button type="link" onClick={handleCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default SsoRedirectingScreen;
